import * as React from 'react';
import PropTypes from 'prop-types';
// import { useAutocomplete } from '@mui/base/useAutocomplete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { AutocompleteGetTagProps, Box, ListItemText, useAutocomplete } from '@mui/material';

const Root = styled('div')(
  ({ theme }) => `
  color: ${theme.palette.mode === 'rgba(255,255,255,0.65)'
    };
  font-size: 14px;
`,
);

const Label = styled('label')`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;

const InputWrapper = styled('div')(
  ({ theme }) => `
  width: 100%;
  color:white;
 
  background-color: #141414;
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #177ddc;
  }

  &.focused {
    border-color: #177ddc;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: #141414;
    color: rgba(255,255,255,0.65);
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`,
);

function Tag(props) {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span>{label}</span>
      <CloseIcon onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const StyledTag = styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: rgba(255,255,255,0.08);
  border: 1px solid #303030;
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: #177ddc;
    background-color: #003b57;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`,
);

const Listbox = styled('ul')(
  ({ theme }) => `
  min-width:600px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: #171717;
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 999999;

  & li {
    padding: 5px 12px;
    display: flex;
    justify-content:space-between;
    align-items: center;
    background-color: #171717;
    color: white;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: #2b2b2b;
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li.${autocompleteClasses.focused} {
    background-color: #003b57;
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`,
);


export default function Addtags({data, setData }) {
  const handleTagChange = (selectedTags) => {
    if (selectedTags.length <= 4) {
      setData((prev) => ({
        ...prev,
        tags: selectedTags
      }));
    }
  };

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: 'customized-hook-demo',
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: top100Films,
    getOptionLabel: (option) => option.title,
    value: data.tags,
    onChange: (event, newValue) => handleTagChange(newValue),
  });

  return (
    <Root>
      <div {...getRootProps()}>
        <InputWrapper ref={setAnchorEl} className={focused ? 'focused' : ''}>
          {value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return <StyledTag key={key} {...tagProps} label={option.title} />;
          })}
          <input {...getInputProps()} placeholder='Add upto 4 tags...' />
        </InputWrapper>
      </div>
      {groupedOptions.length > 0 && data.tags.length < 4 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => {
            const { key, ...optionProps } = getOptionProps({ option, index });
            return (
              <li key={key} {...optionProps}>
                <Box display={"flex"} flexDirection={"column"} gap={"5px"} >
                  <span>{option.title}</span>
                  <div>{option?.year}</div>
                </Box>
                <CheckIcon fontSize="small" />
              </li>
            );
          })}
        </Listbox>
      ) : null}
    </Root>
  );
}

const top100Films = [
  { title: '#javascript', year: 1994 },
  { title: '#reactJs', year: 1972 },
  { title: '#nodeJs', year: 1974 },
  { title: '#expressJs', year: 2008 },
  { title: '#mongoDB', year: 1957 },
  { title: "#SQL", year: 1993 },
];
